import { useTranslation } from "react-i18next";
import "./LastMinuteDealLabel.scss";

const LastMinuteDealLabel = () => {
  const { t } = useTranslation();

  return (
    <div className="last-minute-deal">
      <p className="last-minute-deal__text">{t("LastMinute")}</p>
    </div>
  );
};

export default LastMinuteDealLabel;
